import { Injectable } from "@angular/core";
import { catchError, map } from "rxjs/operators";
import { environment } from "../../../../../../environments/environment";
import * as HSET from "../settings";
import { GenericHttpService } from "../../../../services/generic-http.service";
import { Observable } from "rxjs";
const month = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];
@Injectable({
  providedIn: "root"
})
export class WpSlaTrendService {
  apiUrl = environment.gateWayHost;
  editItem: any;
  constructor(public generic: GenericHttpService) {}

  getSLAtrendData(url, params): Observable<any> {
    const option = {
      method: "GET",
      url: url, // "./assets/data/p-d-otiftrends.json",
      query: params
    };
    return this.generic.httpRequest(option).pipe(
      catchError(this.generic.handleError),
      map(this.processSLAtrendData)
    );
  }
  processSLAtrendData(data: any) {
    const percentage = [],
      quantity = [];
    const labels = data.data[0].WarehouseSlaTrend.map(value => {
      const total =
        value.non_breached_quantity +
        value.breached_quantity;
      const aDate = new Date(value.creation_date);
      percentage.push(
        Number(((value.non_breached_quantity * 100) / total).toFixed(2))
      );
      quantity.push(total + value.in_process_quantity);
      return `${aDate.getDate()} ${month[aDate.getMonth()]}`;
    });

    return { labels, percentage, quantity };
  }

  createChart(chartData, Options) {
    const chart = JSON.parse(JSON.stringify(HSET.chartData));
    chart.xAxis[0].categories = chartData.labels;
    chart.series[0].data = chartData.percentage;
    chart.series[0].name = Options.yaxisleft;
    chart.series[1].data = chartData.quantity;
    chart.series[1].name = "Quantity";
    chart.yAxis[0].title.text = "Percentage";
    chart.yAxis[1].title.text = Options.yaxisright;
    return chart;
  }
}
